// src/components/bot/components/BasicInfoSection.tsx
// 🎨 BASIC INFO SECTION - Name, description, active toggle (100 lines)

import React from 'react';
import styles from '../BotForm.module.css';
import logger from '../../../utils/logger';

interface BasicInfoSectionProps {
  name: string;
  description: string;
  isActive: boolean;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onActiveChange: (isActive: boolean) => void;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  name,
  description,
  isActive,
  onNameChange,
  onDescriptionChange,
  onActiveChange
}) => {
  logger.log('📝 BasicInfoSection: Rendered with name:', name.length, 'chars');

  return (
    <div className={styles.sectionWide}>
      <h3>Bot Information</h3>
      
      {/* 🎯 BOT NAME */}
      <div className={styles.field}>
        <label className={styles.label}>Bot Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Enter a descriptive name for your bot"
          className={styles.input}
          maxLength={100}
        />
        <small className={styles.helpText}>
          Choose a clear name that helps you identify this bot's purpose
        </small>
      </div>

      {/* 🎯 DESCRIPTION */}
      <div className={styles.field}>
        <label className={styles.label}>Description (Optional)</label>
        <textarea
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Describe what this bot does and when it should be used"
          className={styles.textarea}
          rows={3}
          maxLength={500}
        />
        <small className={styles.helpText}>
          Add details about this bot's purpose and functionality for future reference
        </small>
      </div>

      {/* 🎯 ACTIVE TOGGLE */}
      <div className={styles.field}>
        <label className={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => onActiveChange(e.target.checked)}
            className={styles.checkbox}
          />
          <span>Active Bot</span>
        </label>
        <small className={styles.helpText}>
          {isActive 
            ? '✅ Bot is active and will respond to keywords' 
            : '❌ Bot is inactive and will not respond to messages'
          }
        </small>
      </div>
      
    </div>
  );
};

export default BasicInfoSection;